import type { ReactNode } from "react";

/**
 * Page container for main-sidebar destinations that render a single bordered
 * card (Saved Lists, My Stock) - the same frame the account shell draws around
 * its sections, minus the account sub-navigation.
 */
export function PageCard({ children }: { children: ReactNode }) {
  return (
    <div className="mx-auto max-w-[1400px] px-4 py-6 sm:px-6 lg:px-8">
      <div className="border-border bg-card rounded-lg border">{children}</div>
    </div>
  );
}
